"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchModal = exports.getLocalJSDate = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var __1 = require("..");
var luxon_1 = require("luxon");
var Row_1 = require("@amzn/atoz-web/Row");
var Button_1 = require("@amzn/atoz-web/Button");
var Modal_1 = require("@amzn/atoz-web/Modal");
var Text_1 = require("@amzn/atoz-web/Text");
var View_1 = require("@amzn/atoz-web/View");
var Datepicker_1 = require("@amzn/atoz-web/Datepicker");
var Checkbox_1 = require("@amzn/atoz-web/Checkbox");
var MessageBanner_1 = require("@amzn/atoz-web/MessageBanner");
var Col_1 = require("@amzn/atoz-web/Col");
var atoz_dashboard_taa_components_1 = require("@amzn/atoz-dashboard-taa-components");
var DateManagement_1 = require("../../utils/DateManagement");
var luxon_2 = require("luxon");
var hooks_1 = require("../../hooks");
// eslint-disable-next-line no-restricted-globals
var getLocalJSDate = function (dateTime) {
    // eslint-disable-next-line no-restricted-globals
    return new Date(dateTime.get('year'), dateTime.get('month') - 1, dateTime.get('day'));
};
exports.getLocalJSDate = getLocalJSDate;
var PunchModal = function (_a) {
    var ctkPolicy = _a.ctkPolicy, currentSelectedDate = _a.currentSelectedDate, defaultTime = _a.defaultTime, militaryTime = _a.militaryTime, close = _a.close, submit = _a.submit, isMissedPunchModal = _a.isMissedPunchModal, hasUnverifiedMissedPunchLimit = _a.hasUnverifiedMissedPunchLimit, associateInfo = _a.associateInfo;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = react_1.default.useState(currentSelectedDate), selectedDate = _b[0], setSelectedDate = _b[1];
    var _c = react_1.default.useState(defaultTime), punchTime = _c[0], setPunchTime = _c[1];
    var _d = react_1.default.useState(false), inputError = _d[0], setInputError = _d[1];
    var _e = react_1.default.useState(''), inputErrorMessage = _e[0], setInputErrorMessage = _e[1];
    var _f = react_1.default.useState(militaryTime !== null && militaryTime !== void 0 ? militaryTime : true), useMilitaryTime = _f[0], setUseMilitaryTime = _f[1];
    var _g = (0, hooks_1.usePunchLockoutStatus)({
        employeeId: associateInfo.employeeId,
        shouldFetch: hasUnverifiedMissedPunchLimit
    }), _h = _g.data, _j = _h === void 0 ? {} : _h, associateAipLockoutStatus = _j.associateAipLockoutStatus, error = _g.error;
    var lockoutStatusError = (error === null || error === void 0 ? void 0 : error.statusCode) === 503;
    var associateLockoutStatus = associateAipLockoutStatus === null || associateAipLockoutStatus === void 0 ? void 0 : associateAipLockoutStatus.associateAipLockoutStatus;
    var toggleMilitaryTime = function () {
        setUseMilitaryTime(!useMilitaryTime);
        setPunchTime('');
    };
    var validatePunchTime = function (punchTime) {
        return useMilitaryTime
            ? !/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/gm.test(punchTime)
            : !/^(1[0-2]|0?[1-9]):[0-5][0-9] (am|pm)$/gm.test(punchTime);
    };
    var validate = function () {
        var isInvalid = validatePunchTime(punchTime || '');
        if (isInvalid) {
            setInputError(true);
            setInputErrorMessage(t('time_and_attendance_PunchModal_Error_Time'));
            return false;
        }
        var parsedPunchTime = (0, DateManagement_1.parsePunchTime)(punchTime || '', selectedDate, useMilitaryTime);
        if (parsedPunchTime > luxon_1.DateTime.now()) {
            setInputError(true);
            setInputErrorMessage(t('time_and_attendance_PunchModal_Error_Future'));
            return false;
        }
        setInputError(false);
        return true;
    };
    var firstUpdate = react_1.default.useRef(true);
    react_1.default.useEffect(function () {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        validate();
    }, [selectedDate, punchTime]);
    var titleText = isMissedPunchModal
        ? t('time_and_attendance_PunchModal_MissedPunch_title')
        : t('time_and_attendance_PunchModal_PunchCorrection_title');
    var handleSubmit = function () {
        var isValid = validate();
        if (!isValid) {
            var input = document.getElementById('text-time-input');
            input === null || input === void 0 ? void 0 : input.focus();
            return;
        }
        submit(punchTime || '', selectedDate, useMilitaryTime);
    };
    var submitButtonText = ctkPolicy
        ? t('time_and_attendance_PunchModal_MissedPunchCTKSubmit')
        : t('time_and_attendance_PunchModal_Report');
    var submitButton = (react_1.default.createElement(Button_1.Button, { key: "PunchModalSubmitButton", dataTestId: "punch-modal-submit-button", onClick: handleSubmit, variant: Button_1.ButtonVariant.Primary, disabled: hasUnverifiedMissedPunchLimit &&
            associateLockoutStatus === 'LOCKED_OUT' }, submitButtonText));
    var renderMessage = function () {
        if (isMissedPunchModal && !ctkPolicy) {
            return null;
        }
        return (react_1.default.createElement(Text_1.Text, { fontSize: "T200", fontWeight: "light" }, isMissedPunchModal
            ? t('time_and_attendance_PunchModal_MissedPunchCTKMessage')
            : t('time_and_attendance_PunchModal_PunchCorrectionsMessage')));
    };
    var renderAIPLockoutMessage = function () {
        if (!hasUnverifiedMissedPunchLimit ||
            !associateLockoutStatus ||
            associateLockoutStatus === 'OK') {
            return null;
        }
        var bannerType = associateLockoutStatus === 'WARNING'
            ? MessageBanner_1.MessageBannerType.Warning
            : MessageBanner_1.MessageBannerType.Error;
        var bannerMessage = associateLockoutStatus === 'WARNING'
            ? t('time_and_attendance_PunchModal_MissedPunchAIPLockout_Warning')
            : t('time_and_attendance_PunchModal_MissedPunchAIPLockout_Block');
        return (react_1.default.createElement(MessageBanner_1.MessageBanner, { dataTestId: "punch-modal-aip-warning-banner", type: bannerType }, bannerMessage));
    };
    var renderWarning = function () {
        if (isMissedPunchModal && ctkPolicy) {
            return null;
        }
        return (react_1.default.createElement(Text_1.Text, { fontSize: "T200", fontWeight: "light" }, isMissedPunchModal
            ? t('time_and_attendance_PunchModal_MissedPunchSubmissionWarning')
            : t('time_and_attendance_PunchModal_PunchCorrectionsWarning')));
    };
    var textTimeInputClassName = 'time-input form-control' + (!!punchTime ? ' filled' : ' ');
    var textTimeInputClassNameError = 'time-input form-control error';
    var renderPunchDatePicker = function () { return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Text_1.Label, null, t('time_and_attendance_PunchModal_MissedPunchDate')),
        react_1.default.createElement(Datepicker_1.HamiltonDatepicker, { dataTestId: "PunchModalDatePicker", selected: (0, exports.getLocalJSDate)(selectedDate), inline: true, locale: luxon_2.Settings.defaultLocale, showDisabledMonthNavigation: true, formatWeekDay: function (day) {
                return day.substring(0, 3).toLocaleUpperCase();
            }, 
            // eslint-disable-next-line no-restricted-globals
            onChange: function (date) {
                return setSelectedDate((0, DateManagement_1.createDTDayInDefaultTZ)(date));
            }, headerTextProps: { fontSize: 'T400' }, isDateDisabled: function (day) {
                return luxon_1.DateTime.fromISO(day) > luxon_1.DateTime.now();
            }, overrideTodayDate: (0, exports.getLocalJSDate)(luxon_1.DateTime.now()) }))); };
    var renderTimeInput = function () { return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("label", { className: "input-label" }, t('time_and_attendance_PunchModal_MissedPunchTime')),
        react_1.default.createElement(View_1.View, { className: "atoz-filter-text-time-input" },
            react_1.default.createElement(atoz_dashboard_taa_components_1.TextTimeInput, { onChange: setPunchTime, className: inputError
                    ? textTimeInputClassNameError
                    : textTimeInputClassName, value: punchTime || '', placeholder: t('time_and_attendance_PunchModal_EnterTime'), militaryTime: useMilitaryTime, dataTestId: "punch-modal-time-input" }),
            inputError ? (react_1.default.createElement(MessageBanner_1.MessageBanner, { dataTestId: "text-time-input-footer", type: MessageBanner_1.MessageBannerType.Error }, inputErrorMessage)) : ('')),
        react_1.default.createElement(Row_1.Row, { alignItems: "center", gridGap: "S200", margin: { top: 'S400' } },
            react_1.default.createElement(Checkbox_1.Checkbox, { dataTestId: "punch-military-time-checkbox", id: "punch-military-time-checkbox", onChange: toggleMilitaryTime, checked: !useMilitaryTime }),
            react_1.default.createElement(Text_1.Label, { htmlFor: "punch-military-time-checkbox" }, t('time_and_attendance_PunchModal_MissedPunchUseMilitaryTime'))))); };
    var renderPunchErrorModal = function () { return (react_1.default.createElement(Modal_1.Modal, { isOpen: lockoutStatusError, close: close },
        react_1.default.createElement(__1.PunchErrorModal, { retry: close, close: close }))); };
    return (react_1.default.createElement(Modal_1.ModalContent, { dataTestId: "PunchModal", titleText: titleText, buttons: [submitButton], onCloseButtonClick: close, closeButtonAltText: t('time_and_attendance_PunchModal_Close') },
        react_1.default.createElement(Col_1.Col, { gridGap: "S300" },
            renderMessage(),
            renderAIPLockoutMessage(),
            renderPunchDatePicker(),
            renderTimeInput(),
            renderWarning(),
            renderPunchErrorModal())));
};
exports.PunchModal = PunchModal;
